import cn from "clsx";
import { useState } from "react";
import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { Text } from "@components/ui";
import style from "./FaqBlock.module.scss";

export type FaqBlockProps = SliceComponentProps<Content.FaqBlockSlice>;

const FaqBlock = ({ slice }: FaqBlockProps): JSX.Element => {
  const [active, setActive] = useState(-1);

  return (
    <section className={style.section}>
      <>
        <Text variant="span" className={style.categorie}>
          {slice.primary.titreCategorie}
        </Text>
        {slice.items.map((item, index) => (
          <div
            role="presentation"
            className={cn(style.item, { [style.active]: active === index })}
            key={index}
            onClick={() => {
              if (active === index) {
                setActive(-1);

                return;
              }
              setActive(index);
            }}
          >
            <Text variant="span" className={style.label}>
              {item.question}
            </Text>
            <div className={style.text}>
              <PrismicRichText field={item.reponse} />
            </div>
          </div>
        ))}
      </>
    </section>
  );
};

export default FaqBlock;
